export function NotFound() {
  return (
    <main style={{ maxWidth: 360, margin: "10vh auto", padding: 24 }}>
      <h1>Not found</h1>
      <a href="/">Go home</a>
    </main>
  );
}
